@if (appType()) {
  <hr class="w-px h-4 mx-1 shrink-0 border-0 bg-white/[0.18]" />
  <button
    (click)="navigateToProjectHome()"
    class="flex items-center gap-1 h-7 px-2 min-w-0"
    type="button"
  >
    <i
      [class]="appTypeIcon().iconClass"
      [pTooltip]="appTypeIcon().tooltip"
      [showDelay]="TOOLTIP_DEFAULT_DELAY"
      class="ph text-base text-neutral-200"
      tooltipPosition="bottom"
    ></i>
    <!-- Its tooltip shows only while the name is cut. -->
    <span
      [showDelay]="TOOLTIP_DEFAULT_DELAY"
      class="max-w-header-name truncate"
      pTooltip="{{ appTypeIcon().tooltip }} · {{ appName() }}"
      tooltipPosition="bottom"
      showOnEllipsis
      data-testId="application-name"
      >{{ appName() }}</span
    >
  </button>
}

<flx-segmented-button
  [formControl]="tabControl"
  class="flx-ds dark neutral small"
>
  @for (tab of tabs(); track tab.value) {
    <button
      [value]="tab.value"
      [ngClass]="{
        'text-neutral-400': tab.disabled,
        'pointer-events-none': tab.disabled,
      }"
      attr.data-testId="tab-button-{{ tab.value }}"
      flxSegmentedOption
    >
      {{ tab.label }}
    </button>
  }
</flx-segmented-button>

<flx-ai-builder-toggle />

<!-- Only on a page that can be commented on, while the assistant is open. -->
<flx-comment-mode-toggle />

<!-- Pulled 8px into the header's 12px gap, so it sits 4px from the bell like the icons beside it. -->
@if (showLaunch()) {
  <button
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    (click)="launchEntryPoint()"
    class="flx-ds small ternary ml-auto -mr-2"
    flxButton
    type="button"
    icon="center"
    pTooltip="Run project"
    tooltipPosition="bottom"
    data-testid="project-run-button"
    aria-label="Run project"
  >
    <i
      class="ph ph-play"
      flxIcon
    ></i>
  </button>
}
